import { Link } from "react-router-dom"

const AuthLayout = ({ children }: any) => {
  return <>
    <div className="h-screen flex items-center justify-center">

   
    <div className='flex flex-col w-[100%] mx-auto md:w-[30%] '>
    
      {/* <div className="w-[100%] hidden md:block h-full md:w-[50%]  shrink-0">
        <div className="">
          <img src="/assets/img/homeimg.png" alt="logo" className="h-64 object-cover w-full md:h-screen" />
        </div>
      </div> */}
     
       
          <div className="w-full  px-6">
           
            <div className="flex items-center justify-center w-full h-full overflow-auto">{children}</div>
          </div>
       
      
    </div>
    </div>
  </>
}

export default AuthLayout